export default __webpack_public_path__ + "static/media/mail_opened.b48d9748.png";